/**
 * Span of text in the source code.
 */
export type Span = {
	start: number;
	end: number;
};

export class CompileError {
	constructor(
		public readonly message: string,
		public readonly span: Span,
		public readonly errorType: "warning" | "error" = "error"
	) {}
}

/**
 * Internal assertion: No code, no matter how malformed, should trigger this.
 */
export function cafebabeAssert(
	condition: boolean,
	message: string
): asserts condition {
	if (!condition) throw new Error(message);
}

/**
 * Internal assertion that this code should be unreachable.
 */
export function cafebabeUnreachable(message: string): never {
	throw new Error("Unreachable: " + message);
}

export type JavaVersion = 8 | 9 | 10 | 11;
